const errors = {
  9001: 'Un payment est planifié pour cette méthode de paiement.',
};

export default errors;
